var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandSnacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4791 6.82713L44.6 1.92712L43.1729 0.5L41.7458 1.92712L40.4166 0.5L38.9895 1.92712L37.5563 0.5L36.2271 1.92712L34.8 0.5L33.3729 1.92712L31.9396 0.5L30.6105 1.92712L29.1834 0.5L27.7563 1.92712L26.4271 0.5L25 1.92712L23.5729 0.5L22.2438 1.92712L20.8166 0.5L19.3895 1.92712L18.0604 0.5L16.6333 1.92712L15.2 0.5L13.7729 1.92712L12.4438 0.5L11.0166 1.92712L9.58339 0.5L8.25426 1.92712L6.82714 0.5L5.40001 1.92712L6.52089 6.82713C4.57926 18.973 4.57926 31.0209 6.52089 43.1667L5.40001 48.0667L6.82714 49.4939L8.25426 48.0667L9.58339 49.4939L11.0105 48.0667L12.4438 49.5L13.7729 48.0729L15.2 49.5L16.6271 48.0729L18.0543 49.5L19.3834 48.0729L20.8105 49.5L22.2376 48.0729L23.5668 49.5L24.9939 48.0729L26.421 49.5L27.7501 48.0729L29.1773 49.5L30.6044 48.0729L31.9335 49.5L33.3606 48.0729L34.8 49.5L36.2271 48.0729L37.5563 49.5L38.9834 48.0729L40.4105 49.5L41.7396 48.0729L43.1668 49.5L44.5939 48.0729L43.473 43.1729C45.4146 31.0209 45.4146 18.9791 43.4791 6.82713ZM29.0609 32.6379C22.6419 36.0495 15.6226 35.4002 13.3748 31.1801C11.1269 26.96 14.5201 20.7738 20.933 17.3621C27.3459 13.9505 34.3713 14.5998 36.6191 18.8199C38.8609 23.04 35.4799 29.2263 29.0609 32.6379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSnacks);
export default __webpack_public_path__ + "static/media/brandSnacks.3a8cc688304edcc88189139ed2f77b08.svg";
export { ForwardRef as ReactComponent };